export enum AppContactScope {
  CurrentContactId = "CURRENT_CONTACT",
}
